<template>
  <div>
    <div class="demo-spin-article">
      <div class="ts-p-2 ts-rounded-md">
        <div
          class="ts-w-full ts-h-full ts-border-2 ts-border-dashed ts-rounded-md ts-p-3 ts-relative"
        >
          <BasicInfo v-model="model" :validate="errors" ref="basicInfo" />
        </div>
      </div>
      <div class="ts-p-2 ts-rounded-md">
        <ChartOfAccount
          v-model="model"
          :validate="errors"
          ref="ChartOfAccount"
        />
      </div>
      <div class="ts-p-2 ts-rounded-md">
        <ItemDetails v-model="model" :validate="errors" ref="ItemDetails" />
      </div>
      <div class="ts-p-2">
        <div class="ts-flex ts-justify-end ts-space-x-2 ts-sh">
          <ts-button @click.prevent="() => $emit('cancel')" class="btn-gray">
            {{ $t('cancel') }}</ts-button
          >
          <ts-button
            color="primary"
            v-if="!isUpdate"
            outline
            :waiting="waiting_new"
            :disabled="waiting"
            @click.prevent="onSaveAddNew"
          >
            {{ $t('saveAddNew') }}</ts-button
          >
          <ts-button
            color="primary"
            v-if="!isUpdate"
            :waiting="waiting"
            :disabled="waiting_new"
            @click.prevent="onSave"
          >
            {{ $t('save') }}</ts-button
          >
          <ts-button
            v-if="isUpdate"
            color="primary"
            @click.prevent="onUpdate"
            :waiting="waiting"
          >
            {{ $t('update') }}</ts-button
          >
        </div>
      </div>
    </div>
    <Spin size="large" fix v-if="loading"> </Spin>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'
import { isEmpty } from 'lodash'
import moment from 'moment'
import BasicInfo from './components/basic-info.vue'
import ChartOfAccount from './components/chart-of-account.vue'
import ItemDetails from './components/item-details.vue'

export default {
  name: 'journalEntryForm',
  components: {
    BasicInfo,
    ChartOfAccount,
    ItemDetails
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      waiting: false,
      waiting_new: false,
      coaSetupLoading: false,
      coaSetups: [],
      model: {
        transaction_date: moment().format('DD-MM-YYYY'),
        currency_id: null,
        fx_rate: null,
        remarks: null,
        reference_no: null,
        details: []
      }
    }
  },
  async created() {
    await this.setEditData()
    await this.getPreData({
      params: {
        currency_id: this.model.currency_id
      },
      index: undefined
    })
  },
  computed: {
    ...mapState('accounting/journalEntry', ['edit_data']),
    isUpdate() {
      return !isEmpty(this.edit_data)
    }
  },
  methods: {
    ...mapActions('accounting/journalEntry', ['getFormViewModel']),
    async getPreData({ params, index }) {
      this.loading = true
      await this.getFormViewModel({
        index: index,
        params: params
      })
        .catch(error => {
          this.notice({ type: 'error', text: error.message })
        })
        .finally(() => (this.loading = false))
    },
    onSaveAddNew() {
      this.errors = new Errors()
      this.waiting_new = true
      this.$store
        .dispatch('accounting/journalEntry/store', this.model)
        .then(response => {
          this.notice({ type: 'success', text: response.message })
          this.clearInput()
          this.$emit('fetchData')
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.notice({ type: 'error', text: error.message })
        })
        .finally(() => {
          this.waiting_new = false
        })
    },
    onSave() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('accounting/journalEntry/store', this.model)
        .then(response => {
          this.notice({ type: 'success', text: response.message })
          this.$emit('cancel')
          this.$emit('fetchData')
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.notice({ type: 'error', text: error.message })
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onUpdate() {
      this.waiting = true
      this.$store
        .dispatch('accounting/journalEntry/update', {
          id: this.edit_data.transaction_id,
          data: this.model
        })
        .then(response => {
          this.notice({ type: 'success', text: response.message })
          this.$emit('cancel')
          this.$emit('fetchData')
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.notice({ type: 'error', text: error.message })
        })
        .finally(() => {
          this.waiting = false
        })
    },
    async setEditData() {
      if (!isEmpty(this.edit_data)) {
        this.model.transaction_date = this.edit_data.transaction_date
        this.model.currency_id = this.edit_data.currency_id
        this.model.fx_rate = this.edit_data.fx_rate
        this.model.fx_rate_ratio = this.edit_data.fx_rate_ratio
        this.model.remarks = this.edit_data.remarks
        this.model.reference_no = this.edit_data.reference_no
        this.edit_data.details.forEach(detail => {
          this.model.details.push({
            transaction_id: detail.transaction_id,
            account_id: detail.account_id,
            account_number: detail.account.account_number,
            account_name_en: detail.account.account_name_en,
            currency_code: detail.account.currency
              ? detail.account.currency.currency_code
              : '',
            remarks: detail.remarks,
            currency_id: detail.currency_id,
            debit_amount: detail.debit_amount,
            credit_amount: detail.credit_amount,
            display_order: detail.display_order
          })
        })
      } else {
        const default_currency = this.$store.state.exchangeRate.currency.formViewDatas[
          'currencies'
        ].find(el => el.is_default == true)

        this.model.currency_id = default_currency
          ? default_currency.currency_id
          : null
        this.model.fx_rate = 1
        this.model.fx_rate_ratio = 1
      }
    },
    clearInput() {
      this.model.transaction_date = moment().format('DD-MM-YYYY')
      this.model.currency_id = null
      this.model.fx_rate = null
      this.model.remarks = null
      this.model.reference_no = null
      this.model.details = []
    },
    notice(not) {
      this.$Notice[not.type]({
        title: 'JOURNAL ENTRY',
        desc: not.text
      })
    }
  }
}
</script>
<style scoped>
.ivu-table .demo-table-info-row td {
  background-color: #2db7f5;
  color: #fff;
  padding-left: 3px !important;
  padding-right: 3px !important;
}
.ivu-table td.demo-table-info-column {
  background-color: #2db7f5;
  color: #fff;
}
.cursor-pointer {
  cursor: pointer;
}
.form-control {
  height: 32px;
}
</style>
